// import React from 'react';
// import { Link } from 'react-router-dom';
// import './style.css'; // Ensure your styles are updated accordingly

// const Redirect = () => {
//     return (
//         <div className="thank-you-container">
//             <div className="thank-you-content">
//                 <h1 className="thank-you-title">Thank You!</h1>
//                 <p className="thank-you-text">Waiting for approval.</p>
//                 <Link to="/signin">
//                     <button className="button is-primary is-medium cta-button">
//                         Sign In Now
//                     </button>
//                 </Link>
//             </div>
//         </div>
//     );
// };

// export default Redirect;
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Config } from "../.env.js";
import "./style.css";

const Redirect = () => {
    const location = useLocation();
    const email = location.state?.email;

    const [role, setRole] = useState(null);
    const [status, setStatus] = useState("pending");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchRole = async () => {
            if (!email) {
                setError("Email not found, please try again.");
                setLoading(false);
                return;
            }
            try {
                const response = await fetch(`${Config.API_URL}/api/role-redirection`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email }),
                });

                const data = await response.json();
                if (data.success) {
                    setRole(data.role);
                    setStatus(data.status);
                } else {
                    setError(data.message || "Unable to fetch role.");
                }
            } catch (err) {
                setError("Server error while fetching role.");
                console.error("Error fetching role:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchRole();
    }, [email]);

    return (
        <div className="thank-you-container">
            <div className="thank-you-content">
                <h1 className="thank-you-title">Thank You!</h1>

                {loading ? (
                    <p className="thank-you-text">Checking your status...</p>
                ) : error ? (
                    <p className="thank-you-text error">{error}</p>
                ) : role ? (
                    <p className="thank-you-text">
                        Your role is: {role}
                    </p>
                ) : (
                    <p className="thank-you-text">
                        {status === "pending" && "Waiting for approval."}
                        {status === "rejected" && "Your request was rejected."}
                    </p>
                )}

                <Link to="/signin">
                    <button className="button is-primary is-medium cta-button">
                        Sign In Now
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default Redirect;